import { useState } from "react";
import { Package, ArrowsClockwise, X } from "@phosphor-icons/react";

const STORAGE_KEY = "hunt57.mobileLegend.dismissed.v1";

/**
 * One-time legend explaining the icon-only chips on mobile ListingCards.
 * Dismissed forever via localStorage once the user taps the × button.
 * Renders nothing on ≥sm screens — desktop already shows the full labels.
 */
export default function MobileLegend() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; }
    catch { return false; }
  });

  if (dismissed) return null;

  const close = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* private mode */ }
    setDismissed(true);
  };

  return (
    <div
      data-testid="mobile-legend"
      className="sm:hidden mb-3 flex items-center gap-2 border border-white/10 bg-[#0A0A0A] px-3 py-2 text-[10px] leading-none font-mono uppercase tracking-widest"
    >
      <div className="flex-1 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-zinc-400">
        <span className="inline-flex items-center gap-1">
          <Package size={11} weight="bold" className="text-[#007AFF]" />
          Combined ship
        </span>
        <span className="inline-flex items-center gap-1">
          <ArrowsClockwise size={11} weight="bold" className="text-emerald-400" />
          Offers open
        </span>
        <span className="inline-flex items-center gap-1">
          <span className="border border-red-500 text-red-400 px-1 py-0.5 text-[8px] font-bold leading-none">Firm</span>
          Price locked
        </span>
      </div>
      <button
        type="button"
        onClick={close}
        data-testid="mobile-legend-dismiss"
        aria-label="Dismiss legend"
        className="shrink-0 text-zinc-500 hover:text-white p-1 -mr-1"
      >
        <X size={12} weight="bold" />
      </button>
    </div>
  );
}
